export default __webpack_public_path__ + "static/bridges-covid-banner-logo-7427ad8f6cbcec43eecf9469ba2baf24.png";